import { memo } from 'react';
import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { REQUEST_STATUS_CHIP, requestStatusLabelKey } from '../../constants';
import { CHIP_BASE, CHIP_LABEL } from '../../utils';

const CHIP = `${CHIP_BASE} !h-auto !min-h-5 !max-h-none !gap-1.5 !rounded-full !py-0.5`;

/**
 * Request-status pill with a leading color dot. Distinct from integration health
 * `StatusPill` (CT-4195) — this map is the request-status enum only.
 */
const RequestStatusChip = ({ status, priority }) => {
  const { t } = useTranslation('admin-studio');
  const chip = REQUEST_STATUS_CHIP[status] ?? REQUEST_STATUS_CHIP.pending;
  const showHigh = priority === 'high' || priority === 'critical';

  return (
    <div className="flex flex-col items-start gap-1">
      <Badge variant="neutral" size="small" radius="full" className={`${CHIP} ${chip.className}`}>
        <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${chip.dot}`} aria-hidden="true" />
        <span className={CHIP_LABEL}>{t(requestStatusLabelKey(status))}</span>
      </Badge>
      {showHigh ? (
        <span className="text-[10px] font-bold uppercase tracking-[0.08em] text-[#EF4444]">
          {t('integrations.requests.inbox.high')}
        </span>
      ) : null}
    </div>
  );
};

export default memo(RequestStatusChip);
